import React from 'react';
import { SwipeableDrawer, Box } from '@mui/material';
import { TextButton } from 'Components/Button';
import { ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';

export default function MobileDrawer({drawerOpen, setDrawerOpen,drawerData, setShowCompareModal, versionId, setCompareDe, setCompareDeName}) {
    const navigate = useNavigate();

    const toggleDrawer = (openState) => (event) => {
        // Avoid triggering drawer on keyboard navigation tab/shift events
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(openState);
    };

    // Get data element detail page url
    const getDEPath = (verId, deId) =>{
        return PATHS.public['Data Element Detail'].replace(":verId",verId).replace(":deId",deId);
    }

    return (
        <div>
            {
                drawerData!=null && drawerOpen==true
                ?
                    <SwipeableDrawer
                        anchor="bottom" 
                        open={drawerOpen}
                        onClose={toggleDrawer(false)}
                        onOpen={toggleDrawer(true)}
                        disableSwipeToOpen={true}
                        className="swipeable-drawer"
                    >
                        <Box
                            role="presentation"
                            className="box"
                        >   
                            {/* Bar at top of drawer */}
                            <div className="slider"></div>

                            {/* DE details */}
                            <ListGroup.Item className="data-element-card-row">
                                <div className="de-details-row btn btn-de-details">
                                    <div className="de-num">
                                        {drawerData.deCode}
                                        {/* Show red asterisk when 'PSOPPC Only' is not true */}
                                        {drawerData.deAllowSubmit!="No" ? null : <span className="color-error-red">*</span>}
                                    </div>
                                    <div className="de-name">{drawerData.deName}</div>
                                </div>
                            </ListGroup.Item>

                            <div className="d-flex flex-column gap-4 mb-3">
                                {/* Link to view details page */}
                                <TextButton content="View Details" variant="comp-primary" size="lg" onClick={()=>{
                                    navigate(getDEPath(versionId, drawerData.deCode));
                                }}></TextButton>

                                {
                                    // Only H1.2 and H2.0 show compare btn
                                    versionId==444 || versionId == 443
                                    ?
                                        // Compare btn
                                        <TextButton content="Compare" variant="comp-outline" size="lg" onClick={()=>{
                                            setDrawerOpen(false);
                                            setShowCompareModal(true);
                                            setCompareDe(drawerData.deCode);
                                            setCompareDeName(drawerData.deName);
                                        }}></TextButton>
                                    :   null
                                }
                            </div>

                            {/* Close mobile drawer */}
                            <TextButton content="Cancel" variant="comp-plain" size="lg" className="color-error-red" onClick={()=>{
                                setDrawerOpen(false);
                                setShowCompareModal(false);
                                setCompareDe(null);
                                setCompareDeName(null);
                            }}></TextButton>
                        </Box>
                    </SwipeableDrawer>
                :   null
            }
        </div>
    );
}
